import React from 'react';

import { Snackbar } from '@mui/material/';

import { ReactComponent as AlertIcon } from '../../../../assets/icons/v3/alert-circle.svg';
import { ReactComponent as ErrorIcon } from '../../../../assets/icons/v3/error.svg';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/v3/info.svg';
import { ReactComponent as PendingIcon } from '../../../../assets/icons/v3/pending.svg';
import { ReactComponent as SuccessIcon } from '../../../../assets/icons/v3/success.svg';
import { CLOSE_ICON } from '../../../constants/images';
import { IToastProps } from '../../../interfaces/toast';
import { CARD_STATUS_TYPES } from '../../../types/errorHandlingTypes';
import BdsIconButton from '../Buttons/BdsIconButton/BdsIconButton';

import './Toast.scss';

const Toast = ({
  button,
  description,
  icon,
  title,
  open,
  buttonAction,
  handleClose,
  secondaryActionData
}: IToastProps) => {
  const TOASTS_ICONS = {
    success: <SuccessIcon data-testid="success-icon" />,
    error: <ErrorIcon data-testid="error-icon" />,
    informative: <InfoIcon data-testid="info-icon" />,
    alert: <AlertIcon data-testid="alert-icon" />,
    pending: <PendingIcon data-testid="pending-icon" />
  };

  const image = TOASTS_ICONS[icon as CARD_STATUS_TYPES] ?? null;

  return (
    <Snackbar
      className={`snackbar-v3 ${icon} fixed flex`}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      open={open}
      onClose={handleClose}
    >
      <div className="toast-v3">
        {icon && <div className="mr-3 flex items-center">{image}</div>}
        <div className="w-full text-left flex flex-col justify-center">
          {title && <div className="toast-title-font leading-5">{title}</div>}
          {description && <div className="toast-description-font">{description}</div>}
        </div>
        <div className="actions flex flex-row items-center justify-start">
          {secondaryActionData && (
            <button onClick={secondaryActionData.action} className="toast-secondary-button">
              {secondaryActionData.text}
            </button>
          )}
          {button && (
            <div>
              <BdsIconButton
                icon={CLOSE_ICON}
                size="sm"
                variant="transparent"
                action={buttonAction || handleClose}
                label={'close'}
              />
            </div>
          )}
        </div>
      </div>
    </Snackbar>
  );
};

export default Toast;
